<template>
  <div class="offer-footer-card p-3 rounded shadow-sm">
    <div class="row align-items-center">
      <div class="col-md-6 mb-3 mb-md-0">
        <div class="validity-info d-flex align-items-center">
          <i class="fa fa-calendar-check-o text-muted mr-2"></i>
          <div>
            <div class="validity-label text-muted">
              <small>{{ $t('tklifinEtibarllqMddti') }}</small>
            </div>
            <div class="validity-value font-weight-bold">
              {{ validityPeriod || '-' }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 text-md-right">
        <div class="action-buttons">
          <button
            class="btn btn-outline-primary mr-2"
            @click="$emit('start-conversation', userId)"
          >
            <i class="fa fa-comments-o mr-1"></i>
            {{ $t('mzakirEt') }}
          </button>

          <!-- Conditionally show Reject or Undo-Reject button -->
          <template v-if="!rejected">
            <button
              class="btn btn-outline-danger"
              @click.prevent="$emit('open-reject-modal', offerId)"
            >
              <i class="fa fa-ban mr-1"></i>
              {{ $t('detailedComparisonModal.rejectOffer') }}
            </button>
          </template>
          <template v-else>
            <button
              class="btn btn-outline-warning mr-2"
              @click.prevent="$emit('undo-reject-offer', offerId)"
            >
              <i class="fa fa-undo mr-1"></i>
              {{ $t('detailedComparisonModal.unRejectOffer') }}
            </button>
            <button
              class="btn btn-outline-info"
              @click.prevent="$emit('open-reason', rejectReason)"
            >
              <i class="fa fa-eye mr-1"></i>
              {{ $t('detailedComparisonModal.viewReason') || 'Səbəbə bax' }}
            </button>
          </template>
        </div>
      </div>
    </div>

    <!-- Files Section -->
    <div
      v-if="files && files.length"
      class="files-section mt-3"
    >
      <h6 class="files-title mb-2">
        <i class="fa fa-paperclip mr-2"></i>
        {{ $t('detailedComparisonModal.attachedFiles') || 'Əlavə edilmiş fayllar' }}
      </h6>

      <div class="files-container p-3 rounded">
        <div class="d-flex flex-wrap">
          <div
            v-for="(f, ii) in files"
            :key="ii"
            class="file-item mr-3 mb-3"
          >
            <a
              v-if="isPhoto(f)"
              target="_blank"
              :href="getPhoto(f, '')"
              class="file-link"
            >
              <div class="image-preview">
                <img
                  :src="getPhoto(f, 'thumbnailCropped')"
                  class="img-fluid rounded"
                  :alt="$t('newRequest.requestPhoto')"
                >
              </div>
              <div class="file-name mt-1 text-center">
                <small>{{ f.split('/').pop().substring(0, 10) }}{{ f.split('/').pop().length > 10 ? '...' : '' }}</small>
              </div>
            </a>
            <a
              v-else
              target="_blank"
              :href="getPhoto(f, '')"
              class="file-link"
            >
              <div class="file-box">
                <div class="file-icon">
                  <i class="fa" :class="getFileIcon(f)"></i>
                </div>
                <div class="file-extension">
                  {{ f.split('.').pop().toUpperCase() }}
                </div>
              </div>
              <div class="file-name mt-1 text-center">
                <small>{{ f.split('/').pop().substring(0, 10) }}{{ f.split('/').pop().length > 10 ? '...' : '' }}</small>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OfferFooterCard",
  props: {
    validityPeriod: {
      type: String,
      default: ''
    },
    userId: {
      type: Number,
      required: true
    },
    offerId: {
      type: Number,
      required: true
    },
    rejected: {
      type: Boolean,
      default: false
    },
    rejectReason: {
      type: String,
      default: ''
    },
    files: {
      type: Array,
      default: () => []
    },
    isPhoto: {
      type: Function,
      required: false,
      default: () => false
    },
    getPhoto: {
      type: Function,
      required: false,
      default: (file) => file
    }
  },
  methods: {
    getFileIcon(filename) {
      const extension = filename.split('.').pop().toLowerCase();

      // Map common file extensions to Font Awesome icons
      const iconMap = {
        'pdf': 'fa-file-pdf-o',
        'doc': 'fa-file-word-o',
        'docx': 'fa-file-word-o',
        'xls': 'fa-file-excel-o',
        'xlsx': 'fa-file-excel-o',
        'ppt': 'fa-file-powerpoint-o',
        'pptx': 'fa-file-powerpoint-o',
        'txt': 'fa-file-text-o',
        'zip': 'fa-file-archive-o',
        'rar': 'fa-file-archive-o',
        'jpg': 'fa-file-image-o',
        'jpeg': 'fa-file-image-o',
        'png': 'fa-file-image-o',
        'gif': 'fa-file-image-o'
      };

      return iconMap[extension] || 'fa-file-o';
    }
  }
};
</script>

<style scoped>
/* Footer Section */
.offer-footer-card {
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef;
}

.validity-label {
  font-size: 0.85rem;
}

.validity-value {
  font-size: 1rem;
}

/* Files Section */
.files-section {
  border-top: 1px solid #e9ecef;
  padding-top: 1rem;
}

.files-title {
  color: #495057;
  font-weight: 600;
}

.files-container {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
}

.file-item {
  transition: all 0.2s ease;
}

.file-item:hover {
  transform: translateY(-2px);
}

.file-link {
  text-decoration: none;
  color: inherit;
}

.image-preview {
  width: 80px;
  height: 80px;
  overflow: hidden;
  border-radius: 0.25rem;
  border: 1px solid #dee2e6;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-preview img {
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
}

.file-box {
  width: 80px;
  height: 80px;
  border-radius: 0.25rem;
  border: 1px solid #dee2e6;
  background-color: #f8f9fa;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.file-icon {
  font-size: 1.5rem;
  color: #6c757d;
  margin-bottom: 0.5rem;
}

.file-extension {
  font-size: 0.75rem;
  font-weight: 600;
  color: #495057;
}

.file-name {
  font-size: 0.8rem;
  color: #6c757d;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .action-buttons {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .action-buttons button {
    margin-bottom: 0.5rem;
  }
}
</style>
